export default "5a1234c3a9af00d8.png"